import { render, staticRenderFns } from "./LaboratoryRequest.vue?vue&type=template&id=76e68b72"
import script from "./LaboratoryRequest.vue?vue&type=script&lang=js"
export * from "./LaboratoryRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports